export default {
  setAuthorizationType({commit}, type) {
    commit('setAuthorizationType', type);
  },
  setIsPreviousDateSession({commit}, isPreviousDateSession) {
    commit('setIsPreviousDateSession', isPreviousDateSession);
  },
  setPreviousDate({commit}, previousDate) {
    console.info(previousDate)
    commit('setPreviousDate', previousDate);
  },
  setPreviousTime({commit}, previousTime) {
    commit('setPreviousTime', previousTime);
  },
  setPreviousDuration({commit}, previousDuration) {
    commit('setPreviousDuration', previousDuration);
  },
  setUser({commit}, user) {
    commit('setUser', user);
  },
  setClientId({commit}, clientId) {
    commit('setClientId', clientId);
  },
};


// WEBPACK FOOTER //
// ./src/common/auth/vuex/actions.js